
import { useInspectionResultSelectFieldQuery } from 'generated/graphql';

import React from 'react';

export interface IData {
  id: string;
  name: string;
  displayName: string;
}

export function useQuery() {
  const tuple = useInspectionResultSelectFieldQuery({
    variables: {
    }
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.inspectionResults.map((node) => ({
        id: node.id,
        name: node.name,
        displayName: node.displayName
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
    // [tuple]
  );
}
